import { useState, useEffect, useRef, useDebugValue } from "react";
import { useUser } from "../../hooks/useUser";
import apiClient from "../../api/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useQuery } from "@tanstack/react-query";
import useFileUploader from "../../hooks/useFileUploader";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import useProducts from "../../hooks/useProducts";
import Editor from "../../layouts/Editor";
import usePath from "../../hooks/usePath";
import { formToJSON } from "axios";
import SafeImage from "../../components/common/SafeImage";

export default function adminaddorupdate() {
  //Get current login user data
  const { data: user } = useUser();

  //Help to navigate page
  const navigate = useNavigate();

  //Upload image
  const { uploadImage } = useFileUploader();

  // const [productImage, setProductImage] = useState(null);
  // const [productImagePreview, setProductImagePreview] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  //previews Images for produt
  const [previewsImages, setPreviewsImages] = useState([]);

  // disply for error
  const [error, setError] = useState("");

  //Form data for submit the data
  const [formData, setFormData] = useState({
    vendorName: "",
    product_id: 0,
    productName: "",
    productType: "",
    category: "",
    subcategory: "",
    brand: "",
    unit: "",
    tags: [],
    description: "",
    exchangeable: false,
    refundable: true,
    ageValidation: false,
    status: "active",
    old_url: "",
    product_images: [],
    thumbnailImage: null,
    videoProvider: "",
    videoLink: "",
    optionName: "",
    optionValue: [],
    weight: "",
    dimensions: "",
    price: "",
    comparePrice: "",
    costPerItem: "",
    sku: "",
    stockStatus: "In Stock",
    upsells: "",
    crossSells: "",
    pageTitle: "",
    metaDescription: "",
    urlHandle: "",
    taxValue: "",
    variants: [],
    availableFrom: "",
    availableTo: "",
  });

  //For variants
  const [variantFields, setVariantFields] = useState({
    name: "",
    sku: "",
    image: null,
    imagePreview: null,
  });

  const [editIndex, setEditIndex] = useState(null);

  // edit fieldes for product variants
  const [editFields, setEditFields] = useState({
    name: "",
    sku: "",
    image: null,
    imagePreview: null,
  });

  // Add to state for vendor variable prices
  const [variablePrices, setVariablePrices] = useState([]);

  //get parmter variable for id
  const { id } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const source = params.get("source"); // "vendor" or "list"
  const vendorId = params.get("vendor_id"); // For adding products to specific vendor

  //Api get and post

  // Get prodcts by id method will incude
  const { getProductsByid } = useProducts();

  // Always call hooks, but conditionally use their results
  const {
    data: productResult,
    isLoading: Loadingproduct,
    isError: IsErrorProductResult,
    error: productResultError,
    refetch: refetchProducts,
  } = getProductsByid(id);

  // React Query: fetch categories
  const { data: categoriesResult, isLoading: loadingCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: async () => await apiClient.get("/public/categories"),
  });

  // React Query: fetch subcategories
  const {data: subCategoriesResult,isLoading: loadingSubCategories,} = useQuery({
      queryKey: ["subcategories", formData.category],
      queryFn: async () =>
        apiClient.get(
          `/public/subcategories?category_id=${formData.category}`
        ),
      enabled: !!formData.category, 
  });


  //add product data useeffect
  //when id is the parameter, because for edit mode
  useEffect(() => {
    if (!Loadingproduct && productResult?.data && id) {
      setFormData((prev) => ({
        ...prev,
        product_id: productResult?.data?.product_id,
        productName: productResult?.data.product_name || "",
        category: productResult?.data.category_id?.toString() || "",
        subcategory: productResult?.data.subcategory_id?.toString() || "",
        description: productResult?.data.description || "",
        status: productResult?.data.status || "active",
        ageValidation: productResult?.data.age_validation_flag || false,
        product_image: JSON.parse(productResult?.data?.product_image) || [],
        variants:
          productResult?.data?.product_variables?.map((v) => ({
            name: v.variable_name,
            sku: v.sku_id,
            imagePreview: v.image_url,
          })) || [],
      }));

      setPreviewsImages(
        (JSON.parse(productResult?.data?.product_image) || [])?.map((img) => {
          return { url: img };
        })
      );

      if (productResult) {
        setError("No new products available");
      }
    } else {
      setError("No available products found");
    }

    if (!Loadingproduct && IsErrorProductResult) {
      if (productResultError?.response?.status === 403) {
        setError("You must be logged in as a vendor to add products");
      } else {
        setError("Failed to fetch available products. Please try again.");
      }
    }
  }, [Loadingproduct, IsErrorProductResult]);

  // Variant crud
  const handleVariantFieldChange = (e) => {
    const { name, value, type, files } = e.target;
    if (name === "name") {
      const product = (formData.productName || "")
        .replace(/\s+/g, "")
        .toLowerCase();
      const variant = value.replace(/\s+/g, "").toLowerCase();
      setVariantFields((prev) => ({
        ...prev,
        name: value,
        sku: product + variant,
      }));
    } else if (type === "file") {
      const file = files[0];
      setVariantFields((prev) => ({
        ...prev,
        image: file,
        imagePreview: file ? URL.createObjectURL(file) : null,
      }));
    } else {
      setVariantFields((prev) => ({ ...prev, [name]: value }));
    }
  };
  const handleAddVariant = () => {
    if (!variantFields.name.trim()) return;
    setFormData((prev) => ({
      ...prev,
      variants: [...(prev.variants || []), { ...variantFields }],
    }));
    setVariantFields({ name: "", sku: "", image: null, imagePreview: null });
  };

  const handleEditVariant = (index) => {
    setEditIndex(index);
    setEditFields(formData.variants[index]);
  };

  const handleEditFieldChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      setEditFields((prev) => ({
        ...prev,
        image: file,
        imagePreview: file ? URL.createObjectURL(file) : prev.imagePreview,
      }));
    } else {
      setEditFields((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSaveEditVariant = (index) => {
    if (!editFields.name.trim()) return;
    setFormData((prev) => {
      const newVariants = [...prev.variants];
      newVariants[index] = { ...editFields };
      return { ...prev, variants: newVariants };
    });
    setEditIndex(null);
    setEditFields({ name: "", sku: "", image: null, imagePreview: null });
  };

  const handleDeleteVariant = (index) => {
    setFormData((prev) => {
      const newVariants = [...prev.variants];
      newVariants.splice(index, 1);
      return { ...prev, variants: newVariants };
    });
    if (editIndex === index) {
      setEditIndex(null);
      setEditFields({ name: "", sku: "", image: null, imagePreview: null });
    }
  };

  //Is validate field for form
  // Check if form is valid for admin/employee
  const isFormValid = () => {
    if (user?.role === "admin" || user?.role === "employee") {
      return (
        formData.productName &&
        formData.status &&
        formData.category &&
        formData.subcategory &&
        formData.description &&
        getByteSize(formData?.description ?? "") <= 65535 &&
        formData.product_images &&
        (((formData.product_images?.length || 0) > 0 || (previewsImages?.length || 0) > 0) || id)
      );
    }
    return true; // For other cases, let the form handle validation
  };

  //Form value will chage event
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // If vendor or admin/employee with vendorId selects a product, set category as well
    if (
      name === "productName" &&
      (user?.role === "admin" || user?.role === "employee")
    ) {
      // Find the selected product from products list
      const selectedProduct = products.find((p) => p.id == value);
      console.log("Selected product:", selectedProduct);
      console.log("Setting productName to:", value);
      setFormData((prev) => {
        const newData = {
          ...prev,
          [name]: value,
          // Set category if found
          category: selectedProduct ? String(selectedProduct.category_id) : "",
          // Optionally reset subcategory if product changes
          subcategory: "",
          // Don't reset price and taxValue - let user keep their values
        };
        console.log("Updated formData in handleInputChange:", newData);
        return newData;
      });
      return;
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  //Check amount of document size
  function getByteSize(str) {
    return new Blob([str]).size; // gives byte size
  }

  const MAX_SIZE_MB = 2; // 2 MB
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

  // Hanlde all image
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Filter only images <= 2 MB
    const validFiles = [];
    const invalidFiles = [];

    files.forEach((file) => {
      if (file.size <= MAX_SIZE_BYTES) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles?.length > 0) {
      alert(`These files are too large (max 2MB): ${invalidFiles.join(", ")}`);
      // OR use toast.error(...) if you use react-toastify
    }

    setFormData((prev) => ({
      ...prev,
      images: validFiles,
    }));

    const newPreviews = validFiles.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }));

    setPreviewsImages((prev) => [...prev, ...newPreviews]);
  };

  // Remove preview image
  const removeImage = (index) => {
    const updated = previewsImages.filter((_, i) => i !== index);
    setPreviewsImages(updated);
  };

  // Check if user has access to specific sections
  const IsSupperUser = () => {
    if (!user) return false;

    switch (user.role) {
      case "admin":
      case "employee":
        return true; // Admin and employee can access everything
      default:
        return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError("");

      // Admin or employee (only when NOT adding for specific vendor)
      if (user?.role === "admin" || user?.role === "employee") {
        if (
          !formData.productName ||
          !formData.status ||
          !formData.category ||
          !formData.subcategory ||
          (!formData.product_images &&
            (formData.product_images?.length || 0) <= 0) ||
          !formData.description
        ) {
          setError("Please fill in all required fields");
          return;
        }

        const uploadedImageUrls = await Promise.all(
          formData.variants.map(async (variant) => {
            if (variant.image && typeof variant.image !== "string") {
              return usePath(
                await uploadImage(
                  variant.image,
                  "productimages",
                  variant.image.name
                )
              );
            }
            return variant.imagePreview;
          })
        );

        //Uploade image
        const image_res = await Promise.all(
          previewsImages.map(async (product_img) => {
            if (product_img.file && product_img.file !== null) {
              const uploadpath = await uploadImage(
                product_img.file,
                "productimages",
                product_img.file.name
              );

              if (uploadpath) {
                return usePath(uploadpath);
              } else {
                toast.error(`Image upload fail for ${product_img.file.name}`);
                throw new Error(
                  `Image upload fail for ${product_img.file.name}`
                );
              }
            } else if (product_img.url) {
              return product_img.url;
            }
          })
        );

        // id && !formData?.images[0]?.name
        //   ? productResult.data.product_image
        //   : await uploadImage(
        //       formData?.images[0],
        //       "productimages",
        //       formData?.images[0]?.name
        //     );

        if (image_res) {
          const data = {
            category_id: parseInt(formData.category),
            subcategory_id: parseInt(formData.subcategory),
            product_name: formData.productName,
            product_image: JSON.stringify(image_res),
            description: formData.description,
            age_validation_flag: formData.ageValidation,
            status: formData.status,
            variables: formData.variants.map((variant, index) => ({
              sku_id: variant.sku,
              variable_name: variant.name,
              image_url: uploadedImageUrls[index],
            })),
            ...(user?.user_id && { vendor_id: parseInt(vendorId) }), // Add vendor_id if present
          };

          // Make API call to store vendor product
          const response = id
            ? await apiClient.put(`/products/${id}`, data)
            : await apiClient.post("/products", data);

          if (response.data.status === "success") {
            // Show success toast
            toast.success(
              response.data.message ?? "Product added successfully!",
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              }
            );

            // Reset form
            setFormData({
              productName: "",
              category: "",
              subcategory: "",
              product_image: "",
              description: "",
              age_validation_flag: false,
              status: "Active",
            });

            // Refresh the product list
            await refetchProducts();

            // Navigate back to the appropriate page
            navigate("/listofproducts");
          } else {
            setError(response.data.message || "Failed to add product");
          }
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      const errorMessage =
        error?.message || "Failed to add product. Please try again.";

      // Show error toast
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 5000,
        closeOnClick: true,
        closeButton: true,
        draggable: true,
        pauseOnHover: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="mb-4">
        <h2 className="fw-bold">Product Information</h2>
      </div>
      
      <form className="row g-3" onSubmit={handleSubmit}>
            {/* Show vendor context when adding product for specific vendor */}
            {!id &&
              vendorId &&
              (user?.role === "admin" || user?.role === "employee") && (
                <div className="mb-4">
                  <div className="alert alert-info">
                    <i className="ri-information-line me-2"></i>
                    Adding product for Vendor ID: <strong>{vendorId}</strong>
                  </div>
                </div>
              )}

            {/* product name */}
            <div className="mb-4 row align-items-center">
              <label className="form-label-title col-sm-3 mb-0">
                Product Name
              </label>
              <div className="col-sm-9">
                {/* Update */}
                {(user?.role === "admin" || user?.role === "employee") && (
                  // Insert time
                  <input
                    type="text"
                    className="form-control"
                    name="productName"
                    value={formData.productName}
                    onChange={handleInputChange}
                    placeholder="Enter product name"
                    required
                  />
                )}
              </div>
            </div>

            {/* Product Status - only show when not adding for specific vendor */}
            {(user?.role === "admin" || user?.role === "employee") &&
              !vendorId && (
                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Status
                  </label>
                  <div className="col-sm-9">
                    <select
                      value={formData.status}
                      onChange={handleInputChange}
                      className="form-select"
                      name="status"
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              )}

            {/* Category & sub category - only show when not adding for specific vendor */}
            {IsSupperUser() && !vendorId && (
              <>
                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Category
                  </label>
                  <div className="col-sm-9">
                    {loadingCategories ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <select
                        className="form-select"
                        name="category"
                        value={formData.category}
                        onChange={handleInputChange}
                        required
                      >
                        <option disabled value="">
                          Select a category
                        </option>
                        {categoriesResult &&
                          categoriesResult.data &&
                          categoriesResult.data.data?.map(
                            (categories, index) => (
                              <option
                                key={index}
                                value={categories.category_id}
                              >
                                {categories.category_name}
                              </option>
                            )
                          )}
                      </select>
                    )}
                  </div>
                </div>

                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Subcategory
                  </label>
                  <div className="col-sm-9">
                    {loadingSubCategories ? (
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      <select
                        className="form-select"
                        name="subcategory"
                        value={formData.subcategory}
                        onChange={handleInputChange}
                        disabled={!formData.category}
                        required
                      >
                        <option disabled value="">
                          Select a subcategory
                        </option>
                        {formData.category &&
                          subCategoriesResult &&
                          subCategoriesResult?.data?.data.map(
                            (subcat, index) => (
                              <option key={index} value={subcat.subcategory_id}>
                                {subcat.subcategory_name}
                              </option>
                            )
                          )}
                      </select>
                    )}
                  </div>
                </div>

                {/* Variant Section: show only if subcategory is selected */}

                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Variants
                  </label>
                  <div className="col-sm-9">
                    {/* Add Variant Form */}
                    <div className="row g-2 mb-3" style={{ maxWidth: 600 }}>
                      <div className="col" style={{ minWidth: 180 }}>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          placeholder="Size(e.g. S, 500ml)"
                          value={variantFields.name}
                          onChange={handleVariantFieldChange}
                          disabled={!formData.productName}
                        />
                      </div>
                      <div className="col" style={{ minWidth: 180 }}>
                        <input
                          type="text"
                          className="form-control"
                          name="sku"
                          placeholder="SKU (auto)"
                          value={variantFields.sku}
                          readOnly
                        />
                      </div>
                      <div className="col-auto">
                        <input
                          type="file"
                          className="form-control"
                          name="image"
                          accept="image/*"
                          onChange={handleVariantFieldChange}
                          style={{ width: 120 }}
                          disabled={!formData.productName}
                        />
                      </div>

                      {variantFields.imagePreview && (
                        <div className="col-auto">
                          <SafeImage
                            src={variantFields.imagePreview}
                            alt="Preview"
                            style={{
                              width: 40,
                              height: 40,
                              objectFit: "cover",
                              borderRadius: 4,
                            }}
                          />
                        </div>
                      )}

                      <div className="col-auto">
                        <button
                          type="button"
                          className="btn btn-success w-100"
                          onClick={handleAddVariant}
                          disabled={!formData.productName}
                        >
                          <i className="bi bi-plus-circle me-1"></i>Add
                        </button>
                      </div>
                    </div>
                    {/* Variant List */}
                    <ul className="list-group" style={{ maxWidth: 400 }}>
                      {(formData.variants || []).map((variant, idx) => (
                        <li
                          key={idx}
                          className={`list-group-item d-flex align-items-center justify-content-between py-2 px-3 mb-2 shadow-sm rounded variant-row${
                            editIndex === idx
                              ? " bg-warning-subtle border border-warning"
                              : ""
                          }`}
                          style={
                            editIndex === idx
                              ? { boxShadow: "0 0 0 2px #ffc107" }
                              : {}
                          }
                        >
                          {editIndex === idx ? (
                            <div className="row g-2 align-items-center w-100">
                              <div className="col" style={{ minWidth: 180 }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  value={editFields.name}
                                  onChange={handleEditFieldChange}
                                  placeholder="Name"
                                  required
                                />
                              </div>
                              <div className="col" style={{ minWidth: 180 }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="sku"
                                  value={editFields.sku}
                                  onChange={handleEditFieldChange}
                                  placeholder="SKU"
                                  readOnly
                                  required
                                />
                              </div>
                              <div className="col-auto">
                                <input
                                  type="file"
                                  className="form-control"
                                  name="image"
                                  accept="image/*"
                                  onChange={handleEditFieldChange}
                                  style={{ width: 120 }}
                                />
                              </div>
                              {editFields.imagePreview && (
                                <div className="col-auto">
                                  <SafeImage
                                    src={editFields.imagePreview}
                                    alt="Preview"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      objectFit: "cover",
                                      borderRadius: 4,
                                    }}
                                  />
                                </div>
                              )}
                              <div className="col-auto">
                                <div
                                  className="btn-group"
                                  role="group"
                                  aria-label="Edit actions"
                                >
                                  <button
                                    className="btn btn-primary btn-sm"
                                    type="button"
                                    onClick={() => {
                                      if (!editFields.name.trim()) {
                                        toast.error("Name is required!");
                                        return;
                                      }
                                      // If image is not changed, keep the old imagePreview
                                      if (
                                        !editFields.image &&
                                        variant.imagePreview
                                      ) {
                                        editFields.imagePreview =
                                          variant.imagePreview;
                                      }
                                      handleSaveEditVariant(idx);
                                      toast.success("Variant updated locally!");
                                    }}
                                    title="Save"
                                  >
                                    <i className="bi bi-check-lg me-1"></i>
                                    Save
                                  </button>
                                  <button
                                    className="btn btn-secondary btn-sm"
                                    type="button"
                                    onClick={() => setEditIndex(null)}
                                    title="Cancel"
                                  >
                                    <i className="bi bi-x-lg me-1"></i>
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="d-flex flex-wrap align-items-center gap-3">
                                {variant.imagePreview && (
                                  <SafeImage
                                    src={variant.imagePreview}
                                    alt="Preview"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      objectFit: "cover",
                                      borderRadius: 4,
                                    }}
                                  />
                                )}
                                <span
                                  style={{
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {variant.name}
                                </span>
                                {variant.sku && (
                                  <span className="text-muted">
                                    SKU: <b>{variant.sku}</b>
                                  </span>
                                )}
                              </div>
                              <div
                                className="btn-group"
                                role="group"
                                aria-label="Variant actions"
                              >
                                <button
                                  className="btn btn-warning btn-sm"
                                  type="button"
                                  onClick={() => handleEditVariant(idx)}
                                  title="Update"
                                >
                                  <i className="bi bi-pencil-square me-1"></i>
                                  Update
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  type="button"
                                  onClick={() => handleDeleteVariant(idx)}
                                  title="Delete"
                                >
                                  <i className="bi bi-trash me-1"></i>
                                  Delete
                                </button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </>
            )}

            {/* Age Validation Required */}
            {/* {(user?.role === "admin" || user?.role === "employee") &&
              formData.category === "3" && (
                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Age Validation Required
                  </label>
                  <div className="col-sm-9">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="ageValidation"
                        checked={formData.ageValidation}
                        onChange={handleInputChange}
                        id="ageValidationSwitch"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="ageValidationSwitch"
                      >
                        Enable age validation for this product
                      </label>
                    </div>
                  </div>
                </div>
              )} */}

            {/* Editor */}
            {IsSupperUser() && (
              <>
                <label className="form-label-title">Description</label>
                <Editor
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                />
              </>
            )}

            {/* Product Images */}
            {/* <div className="card">
                <div className="card-body">
                  <div className="card-header-2">
                    <h5>Product Images</h5>
                  </div>

                  <div className="theme-form theme-form-2 mega-form">
                    <div className="mb-4 row align-items-center">
                      <div className="col-sm-9">
                        <div
                          style={{
                            display: "flex",
                            alignContent: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <img
                            src={
                              productImagePreview ||
                              formData.product_image ||
                              "/avatar-placeholder.png"
                            }
                            alt="Profile Preview"
                            style={{
                              width: 60,
                              height: 60,
                              objectFit: "cover",
                              borderRadius: "50%",
                              marginLeft: 16,
                              marginRight: 16,
                            }}
                          />

                          <input
                            className="form-control form-choose"
                            type="file"
                            name="images"
                            onChange={handleImageChange}
                            id="formFile"
                            multiple
                            style={{ height: 35, marginTop: 12 }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             */}

            {IsSupperUser() && (
              <div className="container py-5">
                <div className="card p-4">
                  <h4 className="mb-4 fw-semibold">🖼️ Upload Product Images</h4>

                  {/* Upload box */}
                  <label className="upload-box" for="imageUpload">
                    <div>
                      <i className="bi bi-cloud-arrow-up fs-1 text-primary"></i>
                      <h6 className="mt-3 mb-1">Click or drag images here</h6>
                      <p className="text-muted small">
                        Supports JPG, PNG, WEBP up to 2MB each
                      </p>
                    </div>
                    <input
                      type="file"
                      id="imageUpload"
                      multiple
                      accept="image/*"
                      onChange={handleImageChange}
                    />
                  </label>

                  {/* Preview section */}
                  {(previewsImages?.length || 0) > 0 && (
                    <div className="preview-container">
                      {previewsImages.map((img, index) => (
                        <div key={index} className="preview">
                          <SafeImage src={img.url} alt={`preview-${index}`} />
                          <button
                            className="remove-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              removeImage(index);
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="mt-5 mb-4">
              <button
                type="submit"
                className={`btn px-4 ${
                  loading || !isFormValid()
                    ? "btn-secondary disabled"
                    : "btn-primary"
                }`}
                disabled={loading || !isFormValid()}
                style={{
                  opacity: loading || !isFormValid() ? 0.6 : 1,
                  cursor:
                    loading || !isFormValid() ? "not-allowed" : "pointer",
                  position: "relative",
                }}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  "Save Product"
                )}
              </button>
            </div>
          </form>
        </div>
  );
}
